(function() {
  'use strict';

  a3_pilot_reports.directive('courseFooter', courseFooter);


  /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name courseFooter
   * @restrict E
   * @description
   *   Implementation of courseFooter (appears in course view)
   * @example
   *   Usage:
   *   <course-footer></course-footer>
   * @ngInject 
   */
  function courseFooter($location, $routeParams) {
      function link(scope) {
        scope.gotoCalendar = gotoCalendar;
        scope.gotoGroundDuty = gotoGroundDuty;
        scope.gotoCrewRoute = gotoCrewRoute;
        scope.gotoFlight = gotoFlight;

        function gotoCalendar() {
            $location.path("/");
        }

        function gotoGroundDuty() {
            $location.path('/groundDuty/' + Number($routeParams.dutyId));
        }

        function gotoCrewRoute() {
            var dutyNo = scope.crewRouteDuty.DutyNo;
            var dutyDay = scope.crewRouteDuty.DutyDay;
            $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
        }

        function gotoFlight(){
            var flightId = Number($routeParams.flightId)
            $location.path('/flightinfo/' + flightId);
        }

      }

      return {
          restrict: 'E',
          terminal: true,
          templateUrl: "views/Training/course-footer.tpl.html",
          scope: false,
          link: link
      }
  }

})();